"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyledInput = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: ", "em;\n"], ["\n    ", ";\n    margin-bottom: ", "em;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n            width: 100%;\n            max-width: ", ";\n            height: ", "em;\n            border-radius: ", "em;\n            border: 1px solid\n                ", ";\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n            padding: 0 ", "em;\n            margin: 0\n                ", "\n                auto ", "em;\n            font-size: 1em;\n        "], ["\n            width: 100%;\n            max-width: ", ";\n            height: ", "em;\n            border-radius: ", "em;\n            border: 1px solid\n                ", ";\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n            padding: 0 ", "em;\n            margin: 0\n                ", "\n                auto ", "em;\n            font-size: 1em;\n        "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _functions = require("../../functions");

var _inputError = require("./inputError");

var _inputError2 = _interopRequireDefault(_inputError);

var _label = require("./label");

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var types = ["date", "datetime-local", "email", "hidden", "month", "number", "password", "search", "tel", "text", "time", "week"];

var StyledInput = exports.StyledInput = _styledComponents2.default.input(_templateObject, function (props) {
    return types.indexOf(props.type) !== -1 && (0, _styledComponents.css)(_templateObject2, function (props) {
        return props.expanded ? "100%" : "10em";
    }, function (props) {
        return props.theme.input.sizes[props.size];
    }, function (props) {
        return props.theme.input.radius;
    }, function (props) {
        return props.error ? props.theme.input.error.borderColor : props.theme.input.borderColor;
    }, function (props) {
        return props.theme.input.sizes[props.size] / 4;
    }, function (props) {
        return props.expanded || props.align == "right" ? 0 : "0.4em";
    }, function (props) {
        return props.align == "right" ? "0.4em" : 0;
    });
}, function (props) {
    return props.theme.input.margin;
});
var InputField = function InputField(_ref) {
    var type = _ref.type,
        name = _ref.name,
        label = _ref.label,
        readOnly = _ref.readOnly,
        meta = _ref.meta,
        onChange = _ref.onChange,
        error = _ref.error,
        rest = _objectWithoutProperties(_ref, ["type", "name", "label", "readOnly", "meta", "onChange", "error"]);

    var fieldOptions = {};

    if (readOnly) {
        fieldOptions["readOnly"] = "readOnly";
    }

    if (error) {
        fieldOptions["error"] = "error";
    }

    var handleChange = function handleChange(event) {
        onChange({
            name: name,
            value: event.target.value
        });
    };

    return _react2.default.createElement(
        "div",
        null,
        label && _react2.default.createElement(
            _label2.default,
            _extends({ name: name, label: label }, rest),
            label
        ),
        " ",
        _react2.default.createElement(StyledInput, _extends({
            type: type,
            name: name
        }, fieldOptions, {
            onChange: handleChange
        }, rest)),
        _react2.default.createElement(_inputError2.default, { error: error })
    );
};

InputField.displayName = "InputField";

InputField.propTypes = {
    name: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    size: _propTypes2.default.string,
    expanded: _propTypes2.default.bool,
    block: _propTypes2.default.bool,
    input: _propTypes2.default.object,
    type: _propTypes2.default.string,
    label: _propTypes2.default.string,
    readOnly: _propTypes2.default.bool,
    error: _propTypes2.default.string
};

InputField.defaultProps = {
    size: "default",
    expanded: true,
    block: true,
    type: "text",
    readOnly: false,
    error: ""
};

exports.default = InputField;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/input.js
// module id = 1002
// module chunks = 95715928098905 168707334958949